import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { TermsconditionpolicyService } from 'src/app/shared/services/termsconditionpolicy.service';
@Component({
  selector: 'app-payment-option',
  templateUrl: './payment-option.component.html',
  styleUrls: ['./payment-option.component.scss'],
})
export class PaymentOptionComponent implements OnInit {
  @ViewChild('container', { static: false }) tcpTemplate: TemplateRef<any>;

  @Input() invoiceStatus: string;
  @Input() hideManualPaymentOption: boolean = false;
  @Input() showACHPaymentOption: boolean = false;
  @Input() showGooglePayOption: boolean = false;
  @Input() showCreditCardOption: boolean = true;
  @Input() showCashPayment: boolean = true;
  @Input() customerId: number;
  @Input() isPartial: boolean = false;
  @Input() canPayPartial: boolean = true;
  @Input() locationData: any;
  @Input() amount: number;

  isShowPaymentMethods: boolean = false;
  showThirdPartySelection: boolean = false;
  // Third Party T&C
  agreedToTerms: boolean = false;
  currentModal: NgbModalRef;
  tcpTitle: string;
  tcpContent: string;
  policyContent: string;
  termsAndConditionContent: string;

  constructor(
    private modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private tcpService: TermsconditionpolicyService
  ) {}

  ngOnInit() {
    if (!this.canPayPartial) {
      this.isShowPaymentMethods = true;
      this.isPartial = false;
    }

    if (this.showGooglePayOption) {
      this.getTermsPolicy();
    }
  }

  processGooglePayResponse(response: Object) {
    this.modalRef.close({
      option: 'ProcessGooglePayment',
      tokenizationData: response,
      canPayPartial: this.canPayPartial,
      isPartial: this.isPartial,
    });
  }

  showPaymentMethods(isPartial: boolean) {
    this.isShowPaymentMethods = true;
    this.isPartial = isPartial;
  }

  selectPaymentOption(option: string) {
    if (option !== 'ThirdParty') {
      this.showThirdPartySelection = false;
      this.modalRef.close({
        option: option,
        canPayPartial: this.canPayPartial,
        isPartial: this.isPartial,
      });
    } else {
      this.agreedToTerms = false;
      this.showThirdPartySelection = true;
    }
  }

  processGooglePayTransaction(tokenizationData: Object) {
    this.modalRef.close({
      option: 'ProcessGooglePayment',
      tokenizationData: tokenizationData,
      canPayPartial: this.canPayPartial,
      isPartial: this.isPartial,
    });
  }

  back() {
    this.isShowPaymentMethods = false;
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

  // Third Party Functions
  private getTermsPolicy() {
    this.tcpService.getTerms().subscribe((res: any) => {
      if (res) {
        let term = res.filter((item) => {
          return item.Type === 1 && item.IsDefault;
        })[0];

        let policy = res.filter((item) => {
          return item.Type === 2 && item.IsDefault;
        })[0];

        if (term) {
          this.termsAndConditionContent = term.Content;
        }

        if (policy) {
          this.policyContent = policy.Content;
        }
      }
    });
  }

  openTermsAndCondition() {
    this.tcpTitle = 'Terms and Conditions';
    this.tcpContent = this.termsAndConditionContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  openPolicy() {
    this.tcpTitle = 'Policy';
    this.tcpContent = this.policyContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  closeCurrentDialog() {
    this.currentModal.close();
  }
}
